import React from 'react';
import PropTypes from 'prop-types';

import './image.less';

const Image = ({ src, alt, className }) => (
  <div className={`image-element-wrapper ${className || ''}`}>
    <img className="image-element-image" src={src} alt={alt} />
  </div>
);

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Image.displayName = 'Image';

export default Image;
